import { RESET_COMPARISON_SUCCESS } from '../Comparator/Comparator.actions'
import {
  COMPARATORMODALITIES,
  COMPARATORMODALITIES_SUCCESS,
  COMPARATORMODALITIES_ERROR
} from './ComparatorBuyingModalities.actions'

const initialState = {
  data: {
    categories: [],
    chart: [],
    csvStructure: []
  },
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Comparator Modalities's reducer.
 */
const comparatorModalitiesReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case COMPARATORMODALITIES: {
      return { ...state, fetching: true }
    }
    case COMPARATORMODALITIES_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case COMPARATORMODALITIES_ERROR: {
      return { ...state, error: payload.error }
    }
    case RESET_COMPARISON_SUCCESS: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default comparatorModalitiesReducer
